<template>
    <div class="notice-info-wrap">
        <div class="info-wrap">
            <div class="top-logo">
                <img :src="loginT"/>
            </div>
            <div class="content-wrap" v-loading="loading">
                <div class="datail-title">关于“{{content.orderTitle}}”的中标公告</div>
                <div class="time-bar" v-show="content.createTime">
                    <div class="time-info">
                        <span>发布日期：{{content.createTime}}</span>

                    </div>
                </div>
                <div class="artucle-info">
                    <div class="info-a">
                        致：供应商朋友
                    </div>
                    <div class="info-b">
                        关于“{{content.orderTitle}}”询价单号为<span class="link-span" @click="showOrder">{{content.orderCode}}</span>的中标供应商为：{{content.gysName}}
                    </div>
                    <div class="info-c">
                        <div>
                            <p>利联采购部</p>
                            <p>{{date}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import loginT from '../../../assets/login_logo1.png'
import { winBidNoticeById } from '../../../api/notice'
export default {
    props: {

    },
    data() {
        return {
            loginT,
            content:{},
            noticeId:'',
            date:'',
        };
    },
    computed: {

    },
    created() {
        let route = this.$route;
        this.noticeId = route.params.id;  // 详情id
        this.getinfo()
        // let info = localStorage.getItem('editorTest');
        // if(info){
        //     this.content = JSON.parse(info)
        // }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        getinfo(){
            let _this = this;
            this.loading = true;
            winBidNoticeById({id:this.noticeId}).then(({data:res})=>{
                _this.loading = false;
                if(res.code == 0){
                    console.log(res)
                    _this.content = res.data;
                    if(_this.content.createTime){
                        let dateArr = _this.content.createTime.split(' ')[0].split('-')
                        _this.date = `${dateArr[0]}年${dateArr[1]}月${dateArr[2]}日`
                    }
                }
            })
        },
        showOrder(){
            this.$router.push({path: `/inquiryDetail/inquiryDetail?hId=${this.content.orderId}&show=false`});
        },
    },
    components: {

    },
};
</script>

<style lang="scss">
    .notice-info-wrap{
        .link-span{
            cursor: pointer;
            color: #ff9811;
        }
        width: 100%;
        min-height: 100vh;
        background: #F6F9FD;
        .info-wrap{
            width: 1240px;
            margin: 0 auto;
        }
        .top-logo{
            width: 100%;
            height: 40px;
            padding: 20px 0;
            text-align: left;
            img{
                height: 40px;
            }
        }
        .content-wrap{
            width: calc(100% - 40px);
            padding: 20px;
            background: #fff;
            min-height: calc(100vh - 140px);
            .datail-title{
                width: 100%;
                line-height: 30px;
                text-align: center;
                font-size: 20px;
                font-weight: 700;
                color: #535353;
            }
            .time-bar{
                width: 100%;
                display: flex;
                justify-content: center;
                margin-top: 10px;
                margin-bottom: 20px;
                div{
                    padding-top: 10px;
                    border-top:1px solid #e0e0e0 ;
                    font-size: 12px;
                    color: #535353;
                    span{
                        margin: 0 10px;
                    }
                }
            }
            .artucle-info{
                width: calc(100% - 200px);
                padding: 0 100px;
                margin-bottom: 50px;
                font-size: 14px;
                .info-a{
                    color: #666;
                    line-height: 50px;
                }
                .info-b{
                    width: 100%;
                    line-height: 30px;
                    text-indent: 2em;
                    /* font-size: 12px; */
                    color: #333;
                }
                .info-c{
                    margin-top: 100px;
                    overflow: hidden;
                    color: #666;
                    div{
                        text-align: center;
                        float:right;
                    }
                }
            }
        }

    }
</style>
